
//Import React Hooks
import { useEffect, useState } from 'react'

//Import created components
import Creneau from '../../components/creneau/Creneau.jsx'

// API fetch
import axios from "axios";
import { baseURL } from '../../config/api-config.js';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getSelectedCreneaux, getEleves, getResa } from "../../store/selectors.js";

//MUI
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

//data
import mareesList from '../../data/marees.json';


//Utils 
import convertHoraire from '../../utils/convert_horaire.js';
import filterCreneaux from '../../utils/filterCreneaux.js';

//Translate utils :
import { translator } from "../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
const weekday = require('dayjs/plugin/weekday')
dayjs.extend(weekday)



function Journee({ nbjour, date }) {

    let boutonsPlus = [];

    let [showMarees, setShowMarees] = useState(false);
    let [creneaux, setCreneaux] = useState([]);
    let [creneauxExtra, setCreneauxExtra] = useState([]);
    let [creneauxResa, setCreneauxResa] = useState([]);
    let [showOptions, setShowOptions] = useState(false);
    let [newTime, setNewTime] = useState(0);
    let [newDuration, setNewDuration] = useState(2);
    let [newCreneau, setNewCreneau] = useState();
    const [wallyEditor, setWallyEditor] = useState(false);

    let jourSemaine = ["lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

    let allResaInfos = useSelector(getResa);
    const lang = useSelector(getLang) //global state : language
    let modifMode = false;
    if (allResaInfos.CreneauEleves) {
        modifMode = allResaInfos.CreneauEleves.length > 0;
    }

    let mareesVide = { //pour les jours non présents dans maree.json

        date: "-",
        coef: [
            "-",
            "-"
        ],
        pm: [
            "-",
            "-"
        ],
        bm: [
            "-",
            "-"
        ]
    };

    let mareesDuJour = mareesList.find((jour) => (jour.date === dayjs(date).format('YYYY-MM-DD'))) || mareesVide;
    //console.log(mareesDuJour);

    useEffect(() => {
        async function initCreneaux() { //we add this inner function to manage asynchrone
            let creneauxDuJour = await getCreneaux(dayjs(date).format('YYYY-MM-DD'));
            setCreneaux([].concat(creneauxDuJour.sort(
                (p1, p2) => (p1.horaire < p2.horaire) ? -1 : (p1.horaire > p2.horaire) ? 1 : 0)));
            // get list of extra creneaux, after 3pm, for this day
            //setCreneauxExtra(creneaux.filter((creneau) => creneau.horaire > 15));

        } //end of async function

        async function initCreneauxResa() {
            let crenrez = [];
            if (allResaInfos.CreneauEleves) {
                crenrez = await getCreneauxResa(allResaInfos.id_resa);
            }
            setCreneauxResa(crenrez);

        }

        initCreneaux(); //call the inner asnchrone function
        setWallyEditor(allResaInfos.nb_modifs % 2 === 0);
        initCreneauxResa(); //call the inner asnchrone function
        setShowMarees(false); //close Marees tab


    }, [date, newCreneau])

    useEffect(() => {
        setCreneauxExtra(creneaux.filter((creneau) => creneau.horaire > 15));
        //console.log(creneauxExtra);
    }, [creneaux])


    async function getCreneaux(jour) { //jour : date as string

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/creneau/${jour}`,
            });
            //console.log(response);
            const crens = response.data;
            return crens;
        } catch (err) {
            console.error(err);
            return null;
        }
    }



    async function getCreneauxResa(idResa) { //jour : date as string

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/creneau-eleve/resa/${idResa}`,
            });
            //console.log(response);
            const crens = response.data.data;
            return crens;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    async function addCreneaux() { //jour : date as string

        try {
            const response = await axios({
                method: 'POST',
                url: baseURL + `/creneau`,
                data: {
                    date: dayjs(date).format("YYYY-MM-DD"),
                    horaire: getBoutonsPlus()[newTime], //17 or 17.5, depending on index
                    duree: newDuration,
                    qte_moniteurs: 4,
                }
            });
            //console.log(response);
            const creneau = response.data.data;
            return creneau;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    function getBoutonsPlus() {
        boutonsPlus = [];

        if (!dayjs().isAfter(dayjs(date), "day")) { //only for next days

            for (let i = 0; i < 2 - creneauxExtra.length; i++) {
                if (creneauxExtra.length > 0) {
                    let time = creneauxExtra[0].horaire === 17 ? 17.5 : 17;
                    boutonsPlus.push(time);
                }
                else {
                    boutonsPlus.push(17 + i * 0.5);
                }
            }
        }
        return boutonsPlus;
    }

    async function handleConfirm() {
        let reponse = await addCreneaux();
        setNewCreneau(reponse.id_creneau);
        getBoutonsPlus();
        setShowOptions(false);
        setNewTime(0); //reset select time to first item
    }

    function handleClose() {
        setShowOptions(false);
    }




    return (
        <div className="calendar-days-journee">
            <h3 className="calendar-days-journee-title">{jourSemaine[nbjour - 1] + "\n " + dayjs(date).format('DD/M')}</h3>

            <div className="calendar-days-journee-marees">
                <div className="calendar-days-journee-marees-header" onClick={_ => setShowMarees(!showMarees)}>
                    <p>{translator("Marées", lang, "jourTides")}</p>
                    {showMarees == false ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}

                </div>
                {showMarees == true ?
                    <div className="calendar-days-journee-marees-content">
                        <table>
                            <tr>
                                <th>{translator("Basse", lang, "jourTidesLow")}</th>
                                <td>{mareesDuJour.bm[0]}</td>
                                <td>{mareesDuJour.bm[1] && mareesDuJour.bm[1]}</td>
                            </tr>
                            <tr>
                                <th>{translator("Haute", lang, "jourTidesHigh")}</th>
                                <td>{mareesDuJour.pm[0]}</td>
                                <td>{mareesDuJour.pm[1] && mareesDuJour.pm[1]}</td>
                            </tr>
                            <tr>
                                <th>Coef.</th>
                                <td>{mareesDuJour.coef[0]}</td>
                                <td>{mareesDuJour.coef[1] && mareesDuJour.coef[1]}</td>
                            </tr>
                        </table>
                    </div>
                    : null
                }


            </div>

            <div className="calendar-days-journee-creneaux">

                {filterCreneaux(creneaux, wallyEditor, creneauxResa).map((creneau) => (
                    <Creneau key={creneau.id_creneau} creneau={creneau} />
                ))}

                {getBoutonsPlus().length > 0 && modifMode === true && wallyEditor === true ? /* only for wally, add creneau if not already added */
                    <div className="journee-ajout-creneau">
                        <div className="journee-ajout-creneau-top" onClick={_ => setShowOptions(!showOptions)}>
                            <p>Ajouter session</p>
                        </div>
                        {showOptions === true ?
                            <div className="journee-ajout-creneau-bottom">
                                <InputLabel id="label-horaire">Horaire</InputLabel>
                                <Select
                                    className="journee-ajout-creneau-bottom-horaire"
                                    size="small"
                                    value={newTime}
                                    labelId="label-horaire"
                                    onChange={e => setNewTime(e.target.value)}
                                    variant="outlined"
                                    fullWidth
                                >
                                    {
                                        getBoutonsPlus().map((cren, index) => (
                                            <MenuItem key={cren} value={index}>{convertHoraire(cren, "horaire")}</MenuItem>
                                        ))
                                    }

                                </Select>
                                <InputLabel id="label-duration">Durée</InputLabel>
                                <Select
                                    className="journee-ajout-creneau-bottom-duree"
                                    size="small"
                                    value={newDuration}
                                    labelId="label-duration"
                                    onChange={e => setNewDuration(e.target.value)}
                                    variant="outlined"
                                    fullWidth
                                >
                                    <MenuItem value={1}>1h00</MenuItem>
                                    <MenuItem value={1.5}>1h30</MenuItem>
                                    <MenuItem value={2}>2h00</MenuItem>


                                </Select>
                                <Button
                                    className="journee-ajout-creneau-bottom-ok"
                                    variant="contained"
                                    size="small"
                                    fullWidth
                                    /* disabled={newTime === -1} */
                                    onClick={_ => handleConfirm()}
                                >OK</Button>

                                <Button
                                    className="journee-ajout-creneau-bottom-annuler"
                                    variant="contained"
                                    size="small"
                                    fullWidth
                                    onClick={_ => handleClose()}
                                >Annuler</Button>
                            </div>
                            : null}
                    </div>
                    : null}

            </div>

        </div>
    );
}

export default Journee;